import { Navbar, Container } from "react-bootstrap";

export default function NavbarComponent(props) {
  return (
    <Navbar bg="dark" variant="dark" className="navbarOverride">
      <Container>
        <Navbar.Brand href="#home">
          <img
            alt=""
            src="/helping_color.png"
            width="30"
            height="30"
            className="d-inline-block align-top"
            color="white"
          />{" "}
          Make life easy
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}
